import moment from 'moment'
export default {
  computed: {},
  methods: {
    dateFormatter(date, format) {
      return moment(date).format(format)
    },
    utcDateFormatter(date, format) {
      return moment.utc(date).format(format)
    },
    timeSince(date) {
      const now = moment()
      if (moment().subtract(1, 'minutes').isBefore(date)) {
        return 'Just now'
      } else if (moment().subtract(1, 'hours').isBefore(date)) {
        return `${Math.round(moment.duration(now.diff(date)).asMinutes())} m`
      } else if (moment().subtract(1, 'days').isBefore(date)) {
        return `${Math.round(moment.duration(now.diff(date)).asHours())} h`
      } else {
        return moment(date).format('D MMM')
      }
    },
  },
}
